<template>
  <router-link
    :to="`${$store.state.lang ? `/${$store.state.lang}` : ''}/service`"
    class="seasidetms_header_repair_link"
  >
    <span
      class="seasidetms_header_repair_link__icon seasidetms-icon-custom-settings"
    ></span>
  </router-link>
</template>

<script>
export default {
  name: 'RepairLinkMobile',
}
</script>

<style>
.seasidetms_header_repair_link {
  display: none;
}
.seasidetms_header_repair_link__icon {
  display: block;
  font-size: 27px;
}
@media only screen and (max-width: 1024px) {
  .seasidetms_header_repair_link {
    margin-top: 44px;
    display: inline-block;
    float: right;
    margin-right: 5px;
  }
}
@media only screen and (max-width: 768px) {
  .seasidetms_header_repair_link {
    margin-top: 23px;
  }
}
@media only screen and (max-width: 420px) {
  .header_mid .seasidetms_header_repair_link {
    display: none;
  }
}
</style>
